import classNames from 'classnames';
import PageBody from './PageBody.js';
import PageContent from './PageContent.js';
import PageFooter from './PageFooter.js';
import PageHeader from './PageHeader.js';
import PageSection from './PageSection.js';
import React from 'react';
import PropTypes from 'prop-types';

export default function Page({
    children,
    className,
    ...props
}) {
    const classes = classNames(className);
    return (
        <div {...props} className={classes}>
            {children}
        </div>
    );
}

Page.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
};

Page.Body = PageBody;
Page.Content = PageContent;
Page.Footer = PageFooter;
Page.Header = PageHeader;
Page.Section = PageSection;
